import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class NotificationApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Notification;

  constructor(
    private section: string,
    private title: string
  ) {}

  getPayload(): any {
    return {
      section: this.section,
      title: this.title
    };
  }
}
